import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { Gift, Trophy, Zap, Star } from "lucide-react";

const benefits = [
  {
    icon: <Gift className="h-10 w-10 text-primary" />,
    title: "Exklusive Belohnungen",
    description: "Sammle Punkte und tausche sie gegen wertvolle Prämien ein. Je mehr du spielst, desto mehr Belohnungen erhältst du."
  },
  {
    icon: <Trophy className="h-10 w-10 text-primary" />,
    title: "Tägliche Herausforderungen",
    description: "Meistere tägliche Herausforderungen und erhalte zusätzliche Bonuspunkte für deine Erfolge."
  },
  {
    icon: <Zap className="h-10 w-10 text-primary" />,
    title: "Schnelles Gameplay",
    description: "Genieße schnelles und unterhaltsames Gameplay, perfekt für kurze Pausen im Alltag."
  },
  {
    icon: <Star className="h-10 w-10 text-primary" />,
    title: "VIP-Vorteile",
    description: "Erreiche den VIP-Status und erhalte Zugang zu exklusiven Spielen und besonderen Belohnungen."
  }
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};

const BenefitsSection = () => {
  return (
    <section id="benefits" className="py-20 bg-background px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
              Warum du die Rewards App lieben wirst
            </h2>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Entdecke alle Vorteile, die dich in der Rewards App erwarten
            </p>
          </motion.div>
        </div>
        
        <motion.div 
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          {benefits.map((benefit, index) => (
            <motion.div key={index} variants={item}>
              <Card className="h-full border-border hover:border-primary/50 transition-colors duration-300 hover:shadow-md">
                <CardContent className="pt-6">
                  <div className="mb-5 bg-primary/10 w-16 h-16 rounded-full flex items-center justify-center">
                    {benefit.icon}
                  </div>
                  <h3 className="text-xl font-bold mb-2 text-foreground">{benefit.title}</h3>
                  <p className="text-muted-foreground">{benefit.description}</p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default BenefitsSection;